import userService from 'resources/user/user.service';
import dealService from 'resources/deal/deal.service';

import * as dealHelpers from 'resources/deal/deal.helpers';

import { DEALS_STATUSES } from 'resources/user/user.constants';

const actualizeClientStatusAndRoles = async (clientId) => {
  const clientDeals = await dealService.getDealsByClientId(clientId);

  const notFinishedDeals = clientDeals.filter((deal) => !dealHelpers.isFinished(deal));
  const roles = notFinishedDeals.length
    ? [...new Set(notFinishedDeals.map((deal) => deal.type))]
    : [];

  const fieldsToUpdate = {
    roles,
  };

  const hasStartedTransaction = clientDeals.some((d) => dealHelpers.hasStartedTransaction(d));
  const hasNotStartedTransaction = clientDeals.some((d) => dealHelpers.hasNotStartedTransaction(d));
  const hasAllDealsFinished = clientDeals.every((d) => dealHelpers.isFinished(d));

  if (hasStartedTransaction) {
    fieldsToUpdate.deals_status = DEALS_STATUSES.UNDER_CONTRACT;
  }

  if (!hasStartedTransaction && hasNotStartedTransaction) {
    fieldsToUpdate.deals_status = DEALS_STATUSES.ACTIVE;
  }

  if (hasAllDealsFinished) {
    fieldsToUpdate.deals_status = DEALS_STATUSES.INACTIVE;
  }

  return userService.updateUser({
    id: clientId,
    ...fieldsToUpdate,
  });
};

export {
  actualizeClientStatusAndRoles,
};
